import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from './WorkOrderReference.redux';
import { actions as serialNumActions } from './WorkOrderMultiSerialNumber/WorkOrderSerialNumber.redux';
import { useParams } from 'react-router';
import WorkOrderComponentTable from './WorkOrderComponentTable';
import WorkOrderHeader from './WorkOrderHeader';
import WorkOrderSNSummary from './WorkOrderMultiSerialNumber/WorkOrderSNSummary';
import WorkOrderStagesTable from './WorkOrderStagesTable';

const WorkOrderReference = () => {
    const dispatch = useDispatch(),
          params   = useParams(), // returns object that contains all parameters (variables) from the URL
          docNum   = params.docNum;
	
	const isSerialized = useSelector(state => state.workOrderReference.workOrderHeader.IsSerial) === 'TRUE',
	      isReady      = useSelector(state => state.workOrderSerialNum.remainingSNList.length) === 0;

    useEffect(() => {
        dispatch(actions.resetState());
		dispatch(serialNumActions.resetState());
        
		if (docNum) {
            dispatch(actions.setState({ selectedWODocNum: docNum }));
        }
    }, [ dispatch, docNum ]);


    return (
        <>
            <Row gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32,
                }}
            >
                <Col flex="auto">
                    <WorkOrderHeader />
                </Col>

			</Row>

			<Row gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32,
                }}
			>
				{
					(isSerialized && isReady) &&
					<Col flex="auto">
						<WorkOrderSNSummary />
					</Col>
				}
			</Row>


			{/* {
				loading &&
				<LoadingCover />
			} */}
			{
				docNum &&
				<>
					<Row>
						<Col className="ts_full_width" flex="auto">
							<WorkOrderComponentTable />
						</Col>
					</Row>
					

					<Row
						gutter={{
							xs: 8,
							sm: 16,
							md: 24,
							lg: 32,
						}}
					>
						<Col className="ts_full_width" flex="auto">
							<WorkOrderStagesTable />
						</Col>
					</Row>
				</>
			}


        </>
    );
};

export default WorkOrderReference;
